<template>
    <div class="root">
        <div class="row" style="height: 90vh">
            <div class="col-12 d-flex align-items-center justify-content-center">
                <div class="row w-100">
                    <div class="col-lg-4 offset-lg-4">
                        <img src="../../public/img/404.svg" class="img-fluid">
                        <h2 class="text-center mt-5 not-found-text">صفحه مورد نظر وجود ندارد!</h2>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: '404',
    }
</script>

<style scoped lang="scss">

</style>
